import { useContext } from 'react';
import { AppAbility } from '@open-commerce/oc-authorization-policies';

import { AbilityContext } from '../AccessControlContext';

export const useAbilityContext = (): AppAbility => useContext(AbilityContext);
